const DYNAMIC_IMPORT_ERROR_PATTERNS = [
  /ChunkLoadError/i,
  /Loading chunk \S+ failed/i,
  /Failed to fetch dynamically imported module/i,
  /error loading dynamically imported module/i,
  /Importing a module script failed/i,
];

const RELOAD_STORAGE_KEY_PREFIX = 'fluenceur:dynamic-import-reload';

interface RecoveryLocation {
  pathname?: string;
  search?: string;
  reload: () => void;
}

interface RecoveryOptions {
  location?: RecoveryLocation;
  storage?: Storage;
}

function errorText(error: unknown): string {
  if (error instanceof Error) {
    return `${error.name} ${error.message}`;
  }

  return typeof error === 'string' ? error : '';
}

function reloadKey(location: RecoveryLocation): string {
  return `${RELOAD_STORAGE_KEY_PREFIX}:${location.pathname ?? ''}${location.search ?? ''}`;
}

export function isDynamicImportLoadError(error: unknown): boolean {
  const text = errorText(error);
  return DYNAMIC_IMPORT_ERROR_PATTERNS.some((pattern) => pattern.test(text));
}

export function recoverFromDynamicImportLoadError(
  error: unknown,
  options: RecoveryOptions = {}
): boolean {
  if (!isDynamicImportLoadError(error)) {
    return false;
  }

  if (typeof window === 'undefined' && !options.location) {
    return false;
  }

  const location = options.location ?? window.location;
  const storage = options.storage ?? window.sessionStorage;
  const key = reloadKey(location);

  try {
    if (storage.getItem(key) === '1') {
      return false;
    }

    storage.setItem(key, '1');
  } catch {
    return false;
  }

  location.reload();
  return true;
}
